import { useEffect, useState } from "react";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { error } from "console";

// interface RolesInterface {
//     id: number;
//     libelle: string;
//     status: string;
// }
interface RolesInterface {
    [key: string]: any;
}

const useRolesList = (refresh: boolean): RolesInterface[] => {
    const [roles, setRoles] = useState<RolesInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchRoles = async () => {
            axios.get(`${URL_API}/role/all`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setRoles(response.data.roles);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info(error.response.data.message);
                }

                if (error.status === 500) {
                    toast.warning(error.response.data.message);
                }
            })
        };

        fetchRoles();
    }, [refresh]);
    return roles;
};
export default useRolesList;

export const submitData = ({ data }: { data: RolesInterface }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/role/create`, { ...data }, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success("Rôle ajouté avec succès !!");
            onSuccess();
        }

    }).catch(error => {
        // console.error(error.data);
        toast.info(error.response.data.message);
    })

}

export const deleteRole = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/role/delete/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.warning("Rôle Supprimer avec succès")
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
        toast.info('Server Error')
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/role/block/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success("Status Changé avec success")
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}


